/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.mobile-navlink[href="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const trigger = this.closest('.mobile-menu__item--has-items')
                            .querySelector('.mobile-nav__trigger--level-1');
        if (trigger) trigger.click();
      });
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
